import { Badge } from "@/components/ui/badge";

export default function Privacy() {
  return (
    <div className="pt-20" data-testid="privacy-page">
      <section className="py-12 md:py-16 bg-[#f8f8f8]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <Badge className="bg-green-100 text-[#2B7A1E] hover:bg-green-100 mb-4 px-4 py-1.5 text-xs font-semibold tracking-wide rounded-full border-0">Legal</Badge>
          <h1 className="text-4xl sm:text-5xl font-bold text-[#333] tracking-tight mb-3" style={{ fontFamily: 'Montserrat' }}>Privacy Policy</h1>
          <p className="text-gray-500 text-sm">Last updated: January 2025</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 md:px-8 lg:px-12 prose prose-gray max-w-none">
          <div className="space-y-8">
            <div>
              <h2 className="text-xl font-bold text-[#333] mb-3" style={{ fontFamily: 'Montserrat' }}>1. Information We Collect</h2>
              <p className="text-gray-600 leading-relaxed">We may collect personal information such as your name, email address, phone number, company name, and business address when you fill out a contact form, request a quote, or communicate with us. We also collect non-personal information through cookies and analytics tools to improve our website experience.</p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-[#333] mb-3" style={{ fontFamily: 'Montserrat' }}>2. How We Use Your Information</h2>
              <p className="text-gray-600 leading-relaxed">Your information is used to respond to inquiries and provide quotes, process and fulfil orders, improve our products and services, send relevant product updates and industry news (with your consent), and comply with legal obligations.</p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-[#333] mb-3" style={{ fontFamily: 'Montserrat' }}>3. Data Security</h2>
              <p className="text-gray-600 leading-relaxed">We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.</p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-[#333] mb-3" style={{ fontFamily: 'Montserrat' }}>4. Third-Party Services</h2>
              <p className="text-gray-600 leading-relaxed">We may use third-party services such as analytics providers and form processors. These services have their own privacy policies and we encourage you to review them. We do not sell your personal information to third parties.</p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-[#333] mb-3" style={{ fontFamily: 'Montserrat' }}>5. Cookies</h2>
              <p className="text-gray-600 leading-relaxed">Our website may use cookies and similar tracking technologies to enhance your browsing experience. You can choose to disable cookies through your browser settings, though this may affect some functionality.</p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-[#333] mb-3" style={{ fontFamily: 'Montserrat' }}>6. Your Rights</h2>
              <p className="text-gray-600 leading-relaxed">You have the right to access, update, or delete your personal information. To exercise these rights, please contact us at chetankale629@gmail.com or call +91 93093 14713.</p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-[#333] mb-3" style={{ fontFamily: 'Montserrat' }}>7. Contact Us</h2>
              <p className="text-gray-600 leading-relaxed">If you have questions about this Privacy Policy, please contact us at:<br />Shri Ram Frozen Foods<br />Saswad, Pune, Maharashtra 412301<br />Email: shriramfoodsprocessing@gmail.com<br />Phone: +91 83082 03097</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
